// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"55":"c46d25ae","443":"7e4097b4","528":"b1e603d6"}[chunkId] + ".css";
};